import type {
  DataAnalyticsErrorReport,
  DataAnalyticsSuccessReport,
  DataMetricErrorReport,
  DataMetricSuccessReport,
  DataSentryErrorReport,
} from 'src/internal/revamp/telemetry/types';
import type {ObservabilityFns} from 'src/internal/shared/observability/types';

export function logHttpError(
  type: 'GraphQL' | 'Fetch',
  observabilityFns: ObservabilityFns,
  params: DataAnalyticsErrorReport,
) {
  const {analytics, errors, metrics} = observabilityFns || {};

  analytics.track('frontend.data.error', params);

  const metricTags: DataMetricErrorReport = {
    service: params.service,
    project: params.project,
    component: params.component,
    error_expected: params.errorExpected,
    operation_name: params.operationName,
  };

  metrics.increment('frontend.data.error', metricTags);

  if (params.errorExpected || params.project === '<unknown>') {
    return;
  }

  const sentryParams: DataSentryErrorReport = params;

  const project = params.project;
  const errorCode = params.errorCode;
  const operationName = params.operationName;

  const errorMessage = `${type} error '${errorCode}' on operation '${operationName}'`;

  errors.error(errorMessage, {
    project,
    extras: sentryParams,
  });
}

export function logHttpSuccess(
  type: 'GraphQL' | 'Fetch',
  observabilityFns: ObservabilityFns,
  params: DataAnalyticsSuccessReport,
) {
  const {analytics, metrics} = observabilityFns || {};

  analytics.track('frontend.data.success', params);

  const metricTags: DataMetricSuccessReport = {
    service: params.service,
    project: params.project,
    component: params.component,
    operation_name: params.operationName,
  };

  metrics.increment('frontend.data.success', metricTags);
}
